import { Control, FieldValues, Path, useController } from "react-hook-form";

import { Checkbox } from "#shared/view/components/Checkbox";

type Props<T extends FieldValues> = {
  name: Path<T>;
  label: string;
  control: Control<T>;
  disabled?: boolean;
};

export const CheckInput = <T extends FieldValues>({ name, label, control, disabled }: Props<T>) => {
  const { field } = useController({ name, control });
  return (
    <Checkbox
      label={label}
      onChange={field.onChange}
      style={{ marginTop: 12 }}
      checked={field.value}
      disabled={disabled}
    />
  );
};
